import { Linkedin, Mail, Crown } from "lucide-react";
import Reveal from "@/components/Reveal";

const LEADERS = [
  {
    name: "Digantkumar I. Gamit",
    role: "Managing Director · Founder",
    initials: "DG",
    bio: "Steering Sahyog Finance & Noble Infinity's vision of inclusive, no-CIBIL lending across Bharat — with deep roots in Gujarat's microfinance landscape.",
    accent: true,
  },
];

function Initials({ s }) {
  return (
    <div
      className="relative w-full aspect-square rounded-2xl flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #122E5E 0%, #0A1F44 55%, #04102B 100%)",
      }}
    >
      <div className="absolute inset-0 opacity-25 pointer-events-none"
           style={{
             background:
               "radial-gradient(120% 80% at 30% 20%, rgba(212,175,55,0.45), transparent 60%)",
           }}
      />
      <span className="relative font-display text-[64px] md:text-[80px] text-[#F0D788] tracking-tight leading-none">
        {s}
      </span>
      <div className="absolute bottom-3 right-3 w-9 h-9 rounded-full grid place-items-center bg-[#D4AF37]/15 border border-[#D4AF37]/35 text-[#F0D788]">
        <Crown size={16} />
      </div>
    </div>
  );
}

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="relative bg-[#04102B] text-white py-24 md:py-32 overflow-hidden noise-overlay"
    >
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full border border-[#D4AF37]/8" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">
              Leadership
            </span>
            <h2
              data-testid="leadership-heading"
              className="font-display text-[40px] md:text-[58px] mt-5 leading-[1.05]"
            >
              The team behind <em className="not-italic text-[#D4AF37]">Sahyog</em>
            </h2>
            <p className="mt-4 text-white/65 max-w-2xl mx-auto">
              Experienced finance professionals committed to making credit accessible,
              transparent and respectful for every Indian.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {LEADERS.map((p, i) => (
            <Reveal key={p.name} delay={i * 100} className={i === 0 ? "md:col-start-2" : ""}>
              <article
                data-testid={`leader-card-${p.name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                className="group h-full rounded-3xl p-6 md:p-7 bg-gradient-to-b from-white/[0.05] to-transparent border border-[#D4AF37]/30 hover:border-[#D4AF37]/65 transition-all duration-300 relative overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#D4AF37]/15 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />

                <Initials s={p.initials} />

                {p.accent && (
                  <span className="absolute top-9 left-9 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#D4AF37] text-[#0A1F44] text-[10px] font-display font-semibold tracking-wider uppercase">
                    <Crown size={10} /> Founder
                  </span>
                )}

                <div className="mt-5">
                  <h3 className="font-display text-2xl text-white">{p.name}</h3>
                  <div className="mt-1 text-[11px] tracking-[0.22em] uppercase text-[#D4AF37]">
                    {p.role}
                  </div>
                  <p className="mt-4 text-white/65 text-sm leading-relaxed">{p.bio}</p>
                </div>

                <div className="mt-5 flex items-center gap-3">
                  <a
                    href="mailto:info.nobleinfinity@gmail.com"
                    className="w-9 h-9 rounded-full grid place-items-center bg-white/[0.05] border border-[#D4AF37]/25 text-[#F0D788] hover:bg-[#D4AF37]/15 transition"
                    aria-label="Email"
                  >
                    <Mail size={14} />
                  </a>
                  <a
                    href="https://www.sahyogtapi.in"
                    target="_blank"
                    rel="noreferrer"
                    className="w-9 h-9 rounded-full grid place-items-center bg-white/[0.05] border border-[#D4AF37]/25 text-[#F0D788] hover:bg-[#D4AF37]/15 transition"
                    aria-label="LinkedIn"
                  >
                    <Linkedin size={14} />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <p
            data-testid="leadership-footnote"
            className="mt-12 text-center text-white/45 text-xs"
          >
            Additional board members &amp; senior advisors to be announced soon.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
